module.exports = __webpack_public_path__ + "static/media/faq.74cb2e69.png";